import React from "react";
import {
	Box,
	Button,
	Container,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	Tooltip,
	Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

const DataSelect = styled(Select)({
	color: "#292929",
	"& fieldset": {
		borderColor: "#292929",
	},
	"&.MuiOutlinedInput-root.Mui-focused": {
		"& fieldset": {
			borderColor: "#e60b13",
		},
	},
});

const CarrierShipping = ({
	userData,
	carrierDataForm,
	edit,
	toggleEdit,
	carriers,
	handleChange,
	handleSubmit,
}) => {
	return !edit ? (
		<Container>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					pt: 1,
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<LocalShippingOutlinedIcon
						style={{ color: "#000000" }}
						sx={{ fontSize: 25 }}
					/>
					<Typography className="payment_title_typography">
						{userData.clientTranspoName}
					</Typography>
				</Box>
				<Box onClick={toggleEdit} sx={{ cursor: "pointer" }}>
					<Typography
						variant="subtitle1"
						color={(theme) => theme.palette.light.main}
						sx={{
							fontSize: "1rem",
						}}
					>
						Modificar
					</Typography>
				</Box>
			</Box>
		</Container>
	) : (
		<Container maxWidth="md">
			<Box display="flex" justifyContent="end" alignItems="baseline">
				<Box>
					<Tooltip title="Cerrar">
						<IconButton
							size="large"
							aria-label="Cerrar edición de dirección"
							aria-controls="cierre-edición"
							aria-haspopup="false"
							color="inherit"
							sx={{ mt: 1 }}
							onClick={toggleEdit}
						>
							<CloseIcon color="secondary" sx={{ fontSize: "1.5rem" }} />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>
			<FormControl sx={{ mt: 1, mb: 1, width: "100%" }}>
				<InputLabel
					className="inputLabel"
					id="carrierSelect"
					sx={{
						"&.MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
							color: "#292929",
						},
					}}
				>
					{carrierDataForm[0].label}
				</InputLabel>
				<DataSelect
					labelId="carrierSelect"
					name={carrierDataForm[0].id}
					value={carrierDataForm[0].value}
					label="Transporte"
					onChange={handleChange}
					MenuProps={{ style: { maxHeight: "300px" } }}
				>
					{carriers?.map((carrier) => {
						return (
							<MenuItem
								key={carrier.id}
								name={carrier.name}
								value={carrier.name}
								sx={{ textTransform: "capitalize" }}
							>
								{carrier.name}
							</MenuItem>
						);
					})}
				</DataSelect>
				<Typography variant="body1" color="error">
					{carrierDataForm[0].error}
				</Typography>
				<Box sx={{ display: "flex", justifyContent: "center" }}>
					<Button
						id="btnForm"
						type="submit"
						color="brand"
						onClick={handleSubmit}
						variant="contained"
						sx={{
							width: "30%",
							minWidth: "150px",
							mt: 2,
							fontSize: "1rem",
							fontWeight: 700,
							textTransform: "none",
						}}
						style={{ fontFamily: "Quicksand" }}
					>
						Guardar
					</Button>
				</Box>
			</FormControl>
		</Container>
	);
};

export default CarrierShipping;
